import React, { useContext } from "react";
import styled from "styled-components";
import getImageURL from "../../../../controllers/getImageURL";
import formatDate from "../../../../controllers/formatDate";
import SemanticButton from "../../../helperComponents/SemanticButton";
import { useTranslation } from "react-i18next";
import Context from "../../../../Context";

const Card = styled.div`
  border-radius: 15px;
  width: 350px;
  overflow: hidden;
  color: white;
  position: relative;
  transition: all 0.25s ease-in-out;

  cursor: pointer;

  &:hover {
    transform: scale(0.95);
  }

  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--element);

  @media (max-width: 900px) {
    /* width: calc((85vw - 20px) / 2); */
    height: calc((85vw - 20px));
    width: 100%;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 250px;
  overflow: hidden;

  @media (max-width: 900px) {
    height: 100%;
    width: 100%;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Badge = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  background-color: #303030;
  font-weight: 900;
  padding: 5px 15px;
  border-radius: 20px;
  text-transform: capitalize;
  font-size: 10px;
  color: var(--element);
  font-family: var(--headingFont);

  @media (max-width: 900px) {
    font-size: 8px;
  }
`;

const Info = styled.div`
  padding: 25px 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(1deg, black, 70%, transparent);

  @media (max-width: 900px) {
    gap: 8px;
    padding: 20px 13px;
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: var(--accentColor);
  margin: 0;
  padding: 0;
  text-transform: uppercase;
  font-weight: 900;
  font-family: var(--headingFont);

  @media (max-width: 900px) {
    font-size: 13px;
    margin-bottom: 0;
  }
`;

const Subtitle = styled.div`
  font-family: var(--headingFont);
  font-size: 16px;
  color: var(--accentLight);
  font-weight: 700;
  opacity: 0.7;
  @media (max-width: 900px) {
    font-size: 13px;
    font-weight: 700;
  }
`;

const Badge2 = styled(Badge)`
  left: 15px;
  right: unset;
  background: var(--element);
  color: #303030;
`;

export default function ActivityTypeCard({ item }) {
  const { isMobile } = useContext(Context);
  const { t } = useTranslation();

  return (
    <SemanticButton
      style={isMobile ? { width: "100%" } : null}
      href={`/activity-type/?itemID=${item._id}`}
    >
      <Card>
        <ImageContainer>
          <Image src={getImageURL(item.image)} alt="" />

          {item.isBooked ? (
            <Badge>{t("upcomingActivitiesBooked")}</Badge>
          ) : null}
        </ImageContainer>
        <Info>
          <Title>{item.title}</Title>
          <Subtitle>
            {t("duration")} : {item.duration} Min
          </Subtitle>
        </Info>
      </Card>
    </SemanticButton>
  );
}
